import { Controller } from "@hotwired/stimulus"
import findInteractiveElements from "../utilities/find_interactive_elements"

// Connects to data-controller="drawer"
export default class extends Controller {
  connect() {
    // Prevent Turbo from closing the drawer during a morph
    this.#drawerToggle.addEventListener("turbo:before-morph-attribute", (e) => {
      if (e.target == this.#drawerToggle && e.detail.attributeName == "checked" && e.detail.mutationType == "update") {
        e.preventDefault();
      }
    })
    this.#drawerToggle.addEventListener("change", () => {
      this.#updateAccessibility()
    })
    this.#updateAccessibility()
  }

  #updateAccessibility(){
    let interactiveElements = findInteractiveElements(this.#drawerSide)

    if (this.#drawerToggle.checked){
      this.#restoreInteractiveElements(interactiveElements)
      this.#drawerSide.removeAttribute("aria-hidden")
    } else {
      this.#disableInteractiveElements(interactiveElements);
      this.#drawerSide.setAttribute("aria-hidden", "true")
    }
  }

  publishToggled() {
    let eventName
    if (this.#drawerToggle.checked) {
      eventName = "open"
    } else {
      eventName = "close"
    }

    // This `parentElement` dance is to workaround a stimulus bug which doesn't correctly bubble events
    // on nested controllers.
    // https://discuss.hotwired.dev/t/stimulus-dispatching-bubbling-event-in-nested-identical-controller-doesnt-work/5355/4
    this.dispatch(eventName, {target: this.element.parentElement, detail: {drawer: this.element}})
  }

  open(e) {
    this.#drawerToggle.checked = true
  }

  close(e) {
    // If this close action is coming as the result of a another controller dispatching the event,
    // we make sure it's not our controller that triggered the event.
    if (e && e.detail && e.detail.drawer == this.element) {
      return
    }
    this.#drawerToggle.checked = false
  }

  get #drawerToggle() {
    return this.element.querySelector(".drawer-toggle")
  }

  get #drawerSide() {
    return this.element.querySelector(":scope > .drawer-side")
  }

  #restoreInteractiveElements(elements) {
    elements.forEach((element) => {
      if (element.dataset.originalTabindex !== undefined) {
        element.setAttribute("tabindex", element.dataset.originalTabindex);
        delete element.dataset.originalTabindex;
      } else if (element.getAttribute("tabindex") === "-1") {
        element.removeAttribute("tabindex");
      }
    });
  }

  #disableInteractiveElements(elements) {
    elements.forEach((element) => {
      if (element.hasAttribute("tabindex")) {
        element.dataset.originalTabindex = element.getAttribute("tabindex");
      }
      element.setAttribute("tabindex", "-1");
    });
  }
}